<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="wrapper-input-form mx-auto">
        <div class="card shadow-sm p-5 pt-4 border-0 mt-5 mt-md-0">
            <div class="form-section">
                <p class="fw-bold">
                    <span v-for="(item, index) in $root.t('step1.header.titleBold')" :key="index">
                        {{ item }} <br />
                    </span>
                </p>

                <div v-for="(item, index) in $root.t('step1.header')" :key="index">
                    <TitleContent :title.sync="item.titleContent" :content.sync="item.linkContent" />

                    <i
                        class="fa fa-question-circle cursor-pointer"
                        aria-hidden="true"
                        title="Know Your Customer (KYC) documents"
                        @click="showKYCWording()"
                    />

                    <span v-if="index % 2 == 0">
                        <br />
                        <br />
                    </span>
                </div>
            </div>

            <div class="form-section">
                <h2 class="text-header form-section__title">
                    <span v-for="(item, index) in $root.t('step1.policyHolderTitle')" :key="index">
                        {{ item }} <br />
                    </span>
                </h2>
                <p class="fw-bold form-section__description">
                    <span v-for="(item, index) in $root.t('step1.policyHolderDesc')" :key="index">
                        {{ item }} <br />
                    </span>
                </p>
                <PolicyHolderDetail class="form-section__field" />

                <div class="col-md-12">
                    <h5>
                        <div class="d-flex justify-content-start">
                            <label for="policyHolderInsured-yes">
                                <div v-for="(item, index) in $root.t('step1.isPolicyInsured')" :key="index">
                                    {{ item }}
                                </div>
                            </label>
                            <i
                                class="fa fa-question-circle ms-2 cursor-pointer"
                                aria-hidden="true"
                                title="Child only policy"
                                @click="showPolicyHolderToBeInsuredModal()"
                            />
                        </div>
                    </h5>
                    <div>
                        <ValidationProvider v-slot="v" rules="required">
                            <div class="form-check form-check-inline">
                                <label class="form-check-label" for="policyHolderInsured-yes">
                                    <Input
                                        id="policyHolderInsured-yes"
                                        v-model="$formData.policyDetails.policyHolderInsured"
                                        class-name="form-check-input"
                                        input-type="radio"
                                        name="policyHolderInsured"
                                        :checked-value="true"
                                        aria-labelledby="policyHolderInsured-label"
                                        @change.native="policyHolderInsuredChange(true)"
                                    />
                                    {{ $t('common.yesAnswer') }}
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="form-check-label" for="policyHolderInsured-no">
                                    <Input
                                        id="policyHolderInsured-no"
                                        v-model="$formData.policyDetails.policyHolderInsured"
                                        class-name="form-check-input"
                                        input-type="radio"
                                        name="policyHolderInsured"
                                        :checked-value="false"
                                        aria-labelledby="policyHolderInsured-label"
                                        @change.native="policyHolderInsuredChange(false)"
                                        @click.native="showPolicyHolderToBeInsuredModal()"
                                    />
                                    {{ $t('common.noAnswer') }}
                                </label>
                            </div>
                            <span v-if="v.invalid" class="input-error" v-html="v.errors[0]" />
                        </ValidationProvider>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h5 class="form-section__title">
                    <span v-for="(item, index) in $root.t('step1.contactDetailsTitle')" :key="index">
                        {{ item }} <br />
                    </span>
                </h5>
                <p class="fw-bold form-section__description">
                    <span v-for="(item, index) in $root.t('step1.contactDetailsDesc')" :key="index">
                        {{ item }} <br />
                    </span>
                </p>
                <ContactDetail />
            </div>

            <!-- additional family member -->
            <div class="form-section">
                <div>
                    <h2 class="form-section__title">
                        <span v-for="(item, index) in $root.t('step1.additionalFamilyTitle')" :key="index">
                            {{ item }} <br />
                        </span>
                    </h2>
                    <div class="d-grid">
                        <button type="button" class="btn btn-primary" @click="addFamilyMember()">
                            {{ $t('step1.addFamilyBtn') }}
                        </button>
                    </div>
                </div>

                <div v-if="showFamilyMembers" id="additional-family-members" class="accordion mt-3 mb-3">
                    <div
                        v-for="(familyData, index) in form.familyMembers"
                        :key="index"
                        class="accordion-item mb-2 border"
                    >
                        <AdditionalFamilyMember
                            :member-index="index"
                            :policy-holder-insured="form.policyDetails.policyHolderInsured"
                            :is-collapse="isCollapse"
                            @onDelete="showDeleteModal"
                        />
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h2 class="form-section__title">
                    <span v-for="(item, index) in $root.t('step1.policyDetailsTitle')" :key="index">
                        {{ item }} <br />
                    </span>
                </h2>
                <div class="form-section">
                    <div class="col-md-12 form-section__field">
                        <AppInput
                            name="PolicyHolder.StartTime"
                            :label="$root.t('step1.policyStartDate')"
                            rules="required|currencyPayIn"
                        >
                            <!-- <input v-model="form.policyDetails.policyStartDate" type="text" /> -->
                            <AppDatePicker v-model="form.policyDetails.policyStartDate" :disable-date="checkPastDate" />
                        </AppInput>
                    </div>

                    <div class="col-md-12 form-section__field">
                        <AppInput
                            name="PolicyHolder.Currency"
                            :label="$root.t('step1.currencyPayIn')"
                            rules="required|appSelectRequired"
                        >
                            <AppSelect
                                v-model="form.policyDetails.currencyId"
                                :placeholder="$t('common.defaultSelectionValue')"
                                :options="$optionData.currencies"
                            />
                        </AppInput>
                    </div>
                </div>
            </div>
        </div>

        <div
            id="isAnUnmarriedChildAndInFurtherEducationModal"
            class="modal fade"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 id="exampleModalLabel" class="modal-title">Modal title</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div class="modal-body">...</div>
                </div>
            </div>
        </div>

        <!-- Modal confirm family modal-->
        <div
            class="modal fade deleteModal"
            tabindex="-1"
            aria-labelledby="confirmDeleteMemberFamilyModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span v-for="(item, index) in $root.t('popup.confirmRemoveFamily')" :key="index">
                                {{ item }} <br />
                            </span>
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div class="modal-body">
                        <span v-for="(item, index) in $root.t('popup.confirmRemoveFamilyContent')" :key="index">
                            {{ item }} <br />
                        </span>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-primary"
                            data-bs-dismiss="modal"
                            @click="deleteFamilyMember()"
                        >
                            {{ $t('common.ok') }}
                        </button>
                        <button type="button" class="btn btn-default border-secondary" data-bs-dismiss="modal">
                            {{ $t('common.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Helper Modal -->
        <AppModal
            :title="helperTitle"
            :content="helperContent"
            :is-open="openHelperModal"
            :size="2"
            @onClose="openHelperModal = false"
        />
    </div>
</template>

<script>
import PolicyHolderDetail from './PolicyHolderDetail.vue'
import AdditionalFamilyMember from './AdditionalFamilyMember.vue'
import ContactDetail from './ContactDetail.vue'
import AppSelect from '../shared/AppSelect.vue'
import AppModal from '../shared/Modal.vue'
import moment from 'moment'
import Input from '../shared/Input.vue'
import { initFamilyMember, setDefaultPhysicianDetail } from '../../data/formData.js'
import baseApi from '../../api/common/baseApi.js'
import applyOnlineService from '../../api/services/applyOnlineService'
import TitleContent from './TitleContent.vue'
import storage from '../../utils/storage'

export default {
    name: 'PolicyHolder',
    components: {
        PolicyHolderDetail,
        AdditionalFamilyMember,
        ContactDetail,
        AppSelect,
        AppModal,
        // eslint-disable-next-line vue/no-reserved-component-names
        Input,
        TitleContent,
    },
    props: {
        isCollapse: {
            type: Boolean,
            require: true,
        },
    },
    data() {
        return {
            form: this.$formData,
            policyHolder: this.$formData.policyHolder,

            confirmDeleteFamilyModal: null,
            familyIndex: 0,
            showFamilyMembers: true,

            helperModel: null,
            helperTitle: '',
            helperContent: '',
            openHelperModal: false,
            emailContact: '',
        }
    },
    mounted() {
        this.confirmDeleteFamilyModal = new window.bootstrap.Modal(
            this.$el.getElementsByClassName('deleteModal')[0],
            {},
        )

        applyOnlineService.getSpecificConfigLayoutAsync().then((result) => {
            this.emailContact = result.emailContact
        })
    },
    methods: {
        addFamilyMember() {
            let newFamilyMember = initFamilyMember()
            this.form.familyMembers.push(newFamilyMember)
        },
        async deleteFamilyMember() {
            this.showFamilyMembers = false

            // Delete file by family
            if (this.form.familyMembers.length > 0) {
                var familyDelete = this.form.familyMembers[this.form.currentSelectedFamilyIndex]
                setTimeout(() => {
                    baseApi.get(
                        `api/files/removeFamilyFileUpload?formDataId=${this.form.id}&familyId=${familyDelete.id}`,
                    )
                }, 50)
            }

            this.form.familyMembers.splice(this.form.currentSelectedFamilyIndex, 1)

            setTimeout(() => {
                this.showFamilyMembers = true
            }, 50)
        },
        showDeleteModal(memberIndex) {
            this.$formData.currentSelectedFamilyIndex = memberIndex
            this.confirmDeleteFamilyModal.toggle()
        },
        checkPastDate(date) {
            var pastDate = moment().startOf('day').add(-1, 'days')
            return moment(date).startOf('day') <= pastDate
        },
        policyHolderInsuredChange(checked) {
            this.$formData.policyDetails.policyHolderInsured = checked

            storage.setSession('policyHolderInsured', checked)

            if (this.$formData.policyDetails.policyHolderInsured) {
                this.$formData.policyHolder.additionalDetails.physicianDetails = setDefaultPhysicianDetail()
            }
        },
        showPolicyHolderToBeInsuredModal() {
            this.helperTitle = this.$root.t('popup.childOnlyPolicy')
            this.helperContent = this.$root.t('popup.childOnlyPolicyContent')
            this.openHelperModal = true
        },
        showKYCWording() {
            this.helperTitle = this.$root.t('popup.KYCWording')
            this.helperContent = this.$root.t('popup.KYCWordingContent')
            this.openHelperModal = true
        },
    },
}
</script>
 